import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";

var ReachNowIcon = function ReachNowIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83.7 85.1",
    height: "100%",
    width: "100%"
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.9,331l-4.5-15a3,3,0,0,1,.6-2.6l18.9-21.2a2.43,2.43,0,0,1,2.4-.8l10.2,2,2.9-15.9H32.6a10.82,10.82,0,0,0-10.7,10.9v49.87Z",
    transform: "translate(-21.9 -277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,344.3l16.8-19-7.2-23.7-10-2-4.7,26.2a2.49,2.49,0,0,1-1.7,2l-18.7,6.5,1.6,5.2Z",
    transform: "translate(-21.9 -277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,277.5H78.6l-3.1,17,11.6,2.3a2.63,2.63,0,0,1,2,1.8l8.1,26.6a2.61,2.61,0,0,1-.6,2.6L77.8,349.1a2.43,2.43,0,0,1-2.4.8l-26.9-5.4a2.63,2.63,0,0,1-2-1.8l-2-6.6-22.6,7.77v7.83a10.82,10.82,0,0,0,10.7,10.9H94.9a10.82,10.82,0,0,0,10.7-10.9V288.4A10.82,10.82,0,0,0,94.9,277.5Z",
    transform: "translate(-21.9 -277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,296.9l-16.8,19L48,329.3s17.1-6,17-5.9l4.5-24.7Z",
    transform: "translate(-21.9 -277.5)"
  }));
};

export default ReachNowIcon;
//# sourceMappingURL=reachnow-icon.js.map